export default __webpack_public_path__ + "static/media/medium.255d1eb4.svg";